export const apiBasePath = 'https://api.bottlenose.corp.amazon.com';
export const midwayRedirectUrl = '';

export const newScoringSystemWarning = 'Bottlenose is adopting a new scoring system. If you see a \'-\' in the Results column and the attempt state is \'Complete\', it means that the challenge has not been onboarded to the newer scoring system. You can safely ignore that and continue working on the challenge. This will have no effect on the functionality of the platform or the challenges'
export const newScoringSystemWarningDisabledObject = 'BOTSE_SCORING_SYSTEM_ALERT_DISABLED'


// WEBPACK FOOTER //
// ./src/app/res/constants.js